angular.module('iw.frontyard.signup')
    .service('SignupLendingAPIHelper', function ($http,
                                                 $window,
                                                 IwocaCookies,
                                                 FrontyardVersionProvider,
                                                 SignupReasonsForLoanChoices,
                                                 SignupReasonsForLoanChoicesDE) {

        var LENDING_API_STATE_URL = '/api/lending/v1/state/';
        var API_EMAIL_CHECKER_URL = '/api/lending/v1/email_availability/';

        class SignupLendingAPIHelper {

            static getHTTPOptions() {
                if ($window.USER_IS_BROKER === true) {
                    return SignupLendingAPIHelper.getSessionAuthHttpOptions();
                }
                return SignupLendingAPIHelper.getTokenAuthHttpOptions();
            }

            static getTokenAuthHttpOptions() {
                return {
                    headers: {
                        Authorization: 'Token iwoca-9e4606290c6294a6b40e15c9bb75cd2daf0'
                    }
                };
            }

            static getSessionAuthHttpOptions() {
                return {
                    headers: {
                        'X-csrftoken': IwocaCookies.getCsrfToken()
                    }
                };
            }

            static getChoices() {
                switch($window.SITE_CODE) {
                    case 'de':
                        return SignupReasonsForLoanChoicesDE;
                    default:
                        return SignupReasonsForLoanChoices;
                }
            }

            static replaceNonNumericCharacters(number) {
                switch($window.SITE_CODE){
                    case 'de':
                        return number.toString().replace(/[^0-9]+/g, '');
                    default:
                        return number.toString().replace(/[^0-9.]+/g, '');
                }
            }

            static formatNumber(value) {
                switch ($window.SITE_CODE) {
                    case 'pl':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    case 'uk':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    case 'de':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    default:
                        return value;
                }
            }

            getSignupURL(stateKey) {
                switch ($window.SITE_CODE) {
                    case 'pl':
                        if ($window.USER_IS_BROKER === true) {
                            return `/broker/impersonate_customer/${stateKey}/`;
                        }
                        return '/konto/aplikacja/';
                    case 'de':
                        if ($window.USER_IS_BROKER === true) {
                            return `/partner/impersonate_customer/${stateKey}/`;
                        }
                        return '/konto/anmeldung/';
                    case 'uk':
                    default:
                        if ($window.USER_IS_BROKER === true) {
                            return `/broker/impersonate_customer/${stateKey}/`;
                        }
                        return '/account/signup/';
                }
            }

            serializeDataToSend(signupState) {
                var serialised = {
                    application: {
                        people: [{
                            uid: signupState.personUID,
                            first_name: '',
                            last_name: '',
                            roles: ['applicant'],
                            emails: [{
                                email: signupState.email,
                                uid: signupState.emailUID,
                                type: 'primary',
                                marketing_opt_in: {
                                    agreed: signupState.marketingEmails
                                }
                            }],
                        }],
                        requested_products: {
                            credit_facility: {
                                approval: serializeLoanRequest(signupState)
                            }
                        }
                    },
                    ui: {
                        version: {
                            bundleHashName: FrontyardVersionProvider.getVersionHash()
                        }
                    }
                };

                addGoogleOptimiser(serialised);
                addDuration(serialised, signupState);

                return serialised;
            }

            serializeApplication(signupState) {
                const serialized = {
                    requested_products: [serializeLoanRequest(signupState)]
                };

                serialized.requested_products[0].duration = {
                    amount: signupState.duration || 12,
                    unit: 'months'
                };

                if (signupState.duration > 12) {
                    serialized.requested_products[0].product_type = 'business_loan';
                } else {
                    serialized.requested_products[0].product_type = 'credit_facility';
                }

                return serialized;
            }

            generateUUID() {
                var datetime = new Date().getTime();
                var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
                    var random = (datetime + Math.random() * 16) % 16 | 0;
                    datetime = Math.floor(datetime / 16);
                    return (char === 'x' ? random : (random & 0x3 | 0x8)).toString(16);
                });
                return uid;
            }

            isValidEmail(email) {
                var emailHttpOptions = SignupLendingAPIHelper.getTokenAuthHttpOptions();
                emailHttpOptions.params = { email: email };
                emailHttpOptions.cache = true;

                return $http.get(API_EMAIL_CHECKER_URL, emailHttpOptions)
                    .then(function (response) {
                        return { data: response.data.data.available };
                    });
            }

            postData(data) {
                var httpOptions = SignupLendingAPIHelper.getHTTPOptions();
                return $http.post(LENDING_API_STATE_URL, data, httpOptions);
            }

            postApplication(stateKey, data) {
                var httpOptions = SignupLendingAPIHelper.getHTTPOptions();
                return $http.get(this.getSignupURL(stateKey) + '?redirect=no', httpOptions) // Impersonate the customer for the application request.
                    .then(function () {
                        return $http.put('/api/lending/edge/application/' + stateKey + '/', data, httpOptions);
                    });
            }
        }

        function addGoogleOptimiser(serialised) {
            var googleOptimizer = IwocaCookies.getGoogleOptimizer();
            if (angular.isString(googleOptimizer) && googleOptimizer.length > 0) {
                serialised.ui._gaexp = googleOptimizer;
            }
        }

        function addDuration(serialised, signupState) {
            if (isTermLoanProduct(signupState)) {
                serialised.application.requested_products.credit_facility.approval.duration = signupState.duration;
            }
        }

        function serializeLoanRequest(signupState) {
            switch (signupState.urgency) {
                case 1:
                    return {
                        urgency: 'future_use',
                        amount: signupState.requestedAmount
                    };
                case 2:
                    return {
                        urgency: 'weeks',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_purpose: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                case 3:
                    return {
                        urgency: 'asap',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_purpose: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                default:
                    return {};
            }
        }

        function isTermLoanProduct(signupState) {
            return angular.isNumber(signupState.duration);
        }

        return SignupLendingAPIHelper;
    });
